import React from 'react';

import Container from '@src/components/Shared/Container';
import NextImage from '@src/components/Shared/NextImage';
import RenderBodyCopy from '@src/components/Shared/RenderBodyCopy';

import { SolutionQuotePropTypes } from './SolutionQuote.types';
import SectionHeader from '@src/components/Shared/SectionHeader';

const SolutionQuote: React.FC<SolutionQuotePropTypes> = ({ testimonial, reversed = true, className = '' }) => {
  return (
    <>
      <Container className='mb-[0rem]!'>
        <SectionHeader
          className='mb-[0.5rem] justify-center lg:pb-[unset]'
          title={testimonial?.title}
          titleClassName='text-[2.8rem] text-left sm:text-center xl:text-[4.8rem] mb-[2.4rem] leading-[3.2rem] md:leading-[4.6rem] xl:leading-[5.4rem] font-light'
        ></SectionHeader>
      </Container>

      <Container className={`lg:flex ${className}`}>
        <NextImage
          className={`mb-[2.4rem] lg:mb-[unset] lg:hidden`}
          src={testimonial?.profileImage?.url}
          alt={testimonial?.profileImage?.description}
          aspectRatio={testimonial?.profileImage?.width / testimonial?.profileImage?.height}
          width={testimonial?.profileImage?.width}
        />

        <NextImage
          className={`max-3xl:[&>img]:h-auto! hidden lg:relative lg:z-[-5] lg:flex lg:w-[calc(50%+10rem)] [&>img]:my-auto ${
            reversed ? 'order-1 ml-[-10rem]' : 'mr-[10rem]'
          }`}
          src={testimonial?.profileImage?.url}
          alt={testimonial?.profileImage?.description}
        />

        <div className={`lg:relative lg:z-20 lg:w-[50%] lg:py-[10rem] lg:pr-[7rem] lg:pl-[10rem] lg:text-[3.2rem]`}>
          {/* Background */}
          <div
            className={`bg-background-secondary ml-[-10rem] hidden shadow-[0px_0px_25px_5px_rgba(0,0,0,0.05)] lg:absolute lg:top-[50%] lg:z-[-15] lg:block lg:h-[calc(100%-10rem)] lg:w-full lg:translate-y-[-50%] lg:transform`}
          />

          <div className='relative lg:max-w-[51rem]'>
            <span className='font-pt-sans relative hidden text-[#dbdbdb] lg:absolute lg:top-[-6rem] lg:left-[-5rem] lg:block lg:text-[13rem] 2xl:left-[-8rem] 2xl:text-[20rem]'>
              “
            </span>
            <RenderBodyCopy
              className='text-grey mb-[1rem] font-light lg:[&>p]:text-[2.6rem]! xl:[&>p]:text-[3.2rem]!'
              bodyCopy={testimonial?.bodyCopy?.json?.content}
            />
          </div>

          <div className='mt-[3rem] text-right text-[1.6rem] lg:relative lg:right-[0rem] lg:bottom-[-3.5rem]'>
            <p className='font-medium lg:text-[1.8rem] lg:font-bold'>- {testimonial?.name}</p>
            <p className='lg:text-[1.8rem]'>{testimonial?.company}</p>
            <NextImage
              className='mt-[2.4rem] mb-[3rem] w-2xs lg:mt-[1rem] lg:ml-auto lg:w-[27rem]'
              objectFit='contain'
              src={testimonial?.logo?.url}
              alt='Company logo'
            />
          </div>
        </div>
      </Container>
    </>
  );
};

export default SolutionQuote;
